import { useState } from "react";
import { Col, Input, InputGroup, Label, Row } from "reactstrap";
import ReactDatePicker from "react-datepicker";
import { PublishDateTime, PublishStatus } from "../../../../../../constants";
import { useAppDispatch } from "../../../../../../reduxToolkit/hooks";
import { setFormValue } from "../../../../../../reduxToolkit/reducers/eCommerce/addProductSlice";

// This component handles the publish status and date inputs in the add product form.
const PublishStatusDate = () => {
    const dispatch = useAppDispatch()
    const [startDate, setStartDate] = useState<Date | null>(new Date());

    return (
        <>
            <Col sm="6">
                <Row>
                    <Col xs="12">
                        <Label for="validationServer01">{PublishStatus}<span className="text-danger"> *</span></Label>
                        <Input type="select" name="status" onChange={(e) => dispatch(setFormValue({ name: "status", value: e.target.value }))}>
                            <option>Publish</option>
                            <option>Drafts</option>
                            <option>Unpublish</option>
                        </Input>
                        <p className="f-light mt-2">Choose the status</p>
                    </Col>
                </Row>
            </Col>
            <Col sm="6">
                <Row>
                    <Col xs="12">
                        <Label for="validationServer01">{PublishDateTime}</Label>
                        <InputGroup className="flatpicker-calender product-date">
                            <ReactDatePicker className="form-control flatpickr-input" selected={startDate} onChange={(date: Date | null) => setStartDate(date)} />
                        </InputGroup>
                    </Col>
                </Row>
            </Col>
        </>
    )
}
export default PublishStatusDate;